<template>
  <div class="quiz-result">
    <div class="intro mb-3">
      Twoje motto: „Jestem dumny z bycia Polakiem”
    </div>

    <div class="cechy columns d-flex p-2">
      <div class="col-auto pt-3 images">
        <img :src="require('@/assets/images/segmentacja/thumb-wierni-ojczyznie.jpg')"
             alt="group thumbnail"
             class="img-responsive"/>
      </div>
      <div class="pl-4 pl-sm-0 description-col">
        <img :src="require('@/assets/images/segmentacja/icon-wierni-ojczyznie.png')"
             alt="group thumbnail"
             class="img-responsive mb-2 icon"/>
        <p>
          Jesteś patriotą – Polska i&nbsp;sprawy z&nbsp;nią związane
          są dla Ciebie najważniejsze.<br/>
          Historia naszego kraju i&nbsp;postacie z&nbsp;nią związane są dla Ciebie autorytetami,
          które pozwalają na znalezienie Twojej własnej drogi.
        </p>
        <p>
          Cenisz sobie tradycję i&nbsp;wiedzę o przodkach – dzielisz się z&nbsp;nią z&nbsp;bliskimi
          i&nbsp;chcesz ją przekazać swoim dzieciom w&nbsp;przyszłości.
        </p>
        <p>
          Zależy Ci na rodzinie – chcesz, aby każdy w&nbsp;niej miał swoje miejsce
          i&nbsp;swoje obowiązki.
        </p>
        <p>
          Często masz wrażenie, że jednak stary porządek był najlepszy,
          kiedy kobieta zajmowała się domem, a&nbsp;mężczyzna zarabianiem pieniędzy.
        </p>
        <p>
          Nie boisz się głośno wygłaszać swoich poglądów i&nbsp;bronić ich,
          nawet jeżeli w&nbsp;Twoim otoczeniu inni ludzie nie zgadzają się z&nbsp;Tobą.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WierniOjczyznie',
};
</script>

<style scoped>
.intro {
  color: #FFFFFF;
  background: var(--color-wierni-ojczyznie);
  font-size: 1.3em;
  font-weight: 700;
  padding: .6em .8em;
}
</style>
